import LogRocket from 'logrocket';
import { isNotRunningLocally } from '@stilingue/st-environment-controller-utils';

const shouldStartLockRocket = isNotRunningLocally();
const message = 'CONFIDENTIAL INFO';

if (shouldStartLockRocket) {
  LogRocket.init('asbycy/stilingue-dashboard', {
    shouldAugmentNPS: false,
    network: {
      requestSanitizer: request => {
        if (request.url.toLowerCase().indexOf('/auth/') !== -1) {
          request.body = message;
        }

        if (request.headers['stilingue-session-id']) {
          request.headers['stilingue-session-id'] = message;
        }

        if (request.headers['Access-Token']) {
          request.headers['Access-Token'] = message;
        }

        return request;
      },
      responseSanitizer: response => {
        if (response.headers['stilingue-session-id']) {
          response.headers['stilingue-session-id'] = message;
        }

        if (response.headers['warroom-session-id']) {
          response.headers['warroom-session-id'] = message;
        }

        return response;
      },
    },
  });
}

export function insertLogRocketMetadata({
  name,
  email,
  id,
} = {}) {
  if ([shouldStartLockRocket, name, email, id].every(Boolean)) {
    LogRocket.identify(id, {
      name,
      email,
    });
  }
}

